import React, {Suspense, useMemo} from "react";
import {Route, Routes as RRoutes, useLocation, matchPath, useNavigate} from "react-router-dom";
import {Result, Button} from "antd";
import {useAccountStore} from "../../stores/useAccountStore";
import {routeConfig} from "./routes.config";

/**
 * 无权限页面
 */
const NoPermission = () => {
    const navigate = useNavigate();
    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
            <Result
                status="403"
                title="403"
                subTitle="抱歉，您没有权限访问该页面"
                extra={<Button type="primary" onClick={() => navigate('/')}>返回首页</Button>}
            />
        </div>
    );
};

/**
 * 路由守卫：按当前用户 resources 校验访问权限
 * 权限由后端按角色过滤（userResult.resources），这里用 matchPath 匹配当前路径
 */
const RouteGuard = ({children}) => {
    const location = useLocation();
    const {account} = useAccountStore();

    const hasPermission = useMemo(() => {
        const resources = account?.resources || [];
        // 当前路径能匹配到任一有权限的资源 path 即放行（前缀匹配，等价原 v5 的 matchPath(pathname, {path})）
        return resources.some(r => r.path && matchPath({path: r.path, end: false}, location.pathname) != null);
    }, [account, location.pathname]);

    if (!hasPermission) return <NoPermission/>;
    return children;
};

export const Routes = React.memo(() => {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <RRoutes>
                {routeConfig.map((item, index) => {
                    return <Route key={index}
                                  path={item.path}
                                  element={(
                                      <RouteGuard>
                                          <item.component/>
                                      </RouteGuard>
                                  )}></Route>
                })}
            </RRoutes>
        </Suspense>
    );
});
